export default "__VITE_ASSET__D98dhLbe__"